import type {
  CoreCustomer,
  CoreCustomerPayload,
  ParameterID,
} from '@flecto/types'

import { api } from '../../../services/api'

/**
 * Update a customer by ID.
 *
 * @endpoint PUT /api/saas/me/customers/{customerId}
 * @scope saas
 * @see https://flecto.dev/api-4724209
 */
export async function updateCustomer(
  customerId: ParameterID,
  customer: CoreCustomerPayload
): Promise<CoreCustomer> {
  const body: CoreCustomerPayload = customer

  const response = await api.put(`/api/saas/me/customers/${customerId}`, body)

  return response.data.customer
}
